import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
  }

  .ant-btn {
    height: 44px;
  }
`;

export const CountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  margin: 4px 0 8px;
  color: #595959;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LoadMore = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;

  .ant-btn {
    height: 44px;
    min-width: 200px;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 4px;

  .ant-input-affix-wrapper {
    height: 44px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .ant-btn {
    height: 40px;
  }
`;

export const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #91caff;
  border-radius: 8px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 14px;
  cursor: pointer;
  max-width: 100%;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  text-align: center;
  color: #8c8c8c;

  > .anticon {
    font-size: 48px;
    color: #d9d9d9;
  }

  h3 {
    margin: 8px 0 0;
    font-size: 18px;
    font-weight: 600;
    color: #262626;
  }

  .ant-btn {
    height: 44px;
    margin-top: 12px;
  }
`;
